var _path, _path2, _circle, _circle2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    enableBackground: "new",
    d: "M35 0h-32c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3v-18c0-1.7-1.4-3-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2h-32c-1.1 0-2-.9-2-2v-18c0-1.1.9-2 2-2h32"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#CE4549",
    cx: 15,
    cy: 12,
    r: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAA2E",
    cx: 23,
    cy: 12,
    r: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f73",
    d: "M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 11h14v2h-14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.564808b93a317688418a3af1e94b363d.svg";
export { ForwardRef as ReactComponent };